import { IconButton, Tooltip } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CampaignIcon from '@mui/icons-material/Campaign';
import MyActionsCardModal from '../pages/MyActions/components/MyActionsCardModal/MyActionsCardModal';
import useAuth from './useAuth';
import { PermissionCodes } from '../utils/constants';
import { PermissionRights } from '../components/Guards/PermissionGuard/PermissionGuard';

export default function useActionCreation({
  dialogTitleKey = 'Dialog_Title_NewActionForJob',
  belongsTo = 'Job',
  sourceLinkCallback,
}) {
  const { t } = useTranslation();
  const [actionObject, setActionObject] = useState(null);
  const closeActionCreationHandler = () => setActionObject(null);

  const { isAuthorized } = useAuth();
  const hasRightToCreateAction = isAuthorized({ permissionCode: PermissionCodes.MyActions, right: PermissionRights.Edit });
  // console.log('User has permission to create action:', hasRightToCreateAction);

  const actionCreationDialog = actionObject && (
    <MyActionsCardModal
      onClose={closeActionCreationHandler}
      open
      belongsTo={belongsTo}
      recordID={actionObject.id}
      sourceLink={sourceLinkCallback ? sourceLinkCallback(actionObject) : null}
      dialogTitle={t(dialogTitleKey, {
        name: actionObject.text,
      })}
    />
  );

  const iconButtonComponent = useCallback(
    ({ id, text }) => {
      if (!hasRightToCreateAction) {
        return null;
      }

      return (
        <Tooltip title={t('Tooltip_CreateAction')}>
          <IconButton
            aria-label="createAction"
            size="small"
            onClick={() => setActionObject({ id, text })}
            color="primary"
          >
            <CampaignIcon size="small" fontSize="inherit" color="action" />
          </IconButton>
        </Tooltip>
      );
    },

    [hasRightToCreateAction, t]
  );

  return {
    actionDialogComponent: actionCreationDialog,
    buttonLinkBuilder: iconButtonComponent,
  };
}
